import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Project from './components/Projects';
import './App.css';
import OldWork from './pages/OldWork';
import About from './pages/About';
import Contact from './pages/Contact';
import Home from './pages/Work';
import ProjectStryk from './pages/ProjectStryk';
import ProjectBuxZero from './pages/ProjectBuxZero';
import ProjectWonderkind from './pages/ProjectWonderkind';
import ScrollToTop from './components/Scroll-top'; // Import the component
import MusicPlayer from './pages/MusicPlayer';
import Footer from './components/Footer';


const App = () => {
  return (

    <div className='wrapper'>
    <Router>
    <ScrollToTop />
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/ProjectStryk" element={<ProjectStryk />} />
          <Route path="/ProjectBuxZero" element={<ProjectBuxZero />} />
          <Route path="/ProjectWonderkind" element={<ProjectWonderkind />} />
          <Route path="/MusicPlayer" element={<MusicPlayer />} />
          <Route path="/Home" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </Router>
    </div>


   
  );
};

export default App;